import React, { useState } from 'react';
import { Card, Table, Loader, Popup } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { formatAmount } from 'lib/currencies';
import { ErrorPage } from 'components/utility/ErrorPage';
import Pager from '@uniiverse/library/components/pagination';
import styles from './RequestedFunds.css';
import locale from '../locale';
import requestedFundsQuery from './requestedFunds.gql';

const RequestedFunds = injectIntl(({ intl: { formatMessage }, intl, user, currency }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const paginationLimit = 5;

  const { data, loading, error, fetchMore } = useQuery(requestedFundsQuery, {
    variables: { id: user.id, currency, offset: 0, limit: paginationLimit },
  });

  if (loading) return <Loader active />;
  if (error) return <ErrorPage />;
  if (data.host.withdrawals.totalCount === 0) return null;

  const { nodes: withdrawals, totalCount } = data.host.withdrawals;
  const totalPages = Math.ceil(totalCount / paginationLimit);

  const changePage = page => {
    fetchMore({
      variables: { offset: page.selected * paginationLimit },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return { ...prev, ...fetchMoreResult };
      },
    });
    setCurrentPage(page.selected + 1);
  };

  return (
    <Card fluid styles={styles.fundsCard}>
      <Card.Content>
        <Card.Header>{formatMessage(locale.requestedFunds)}</Card.Header>
        {formatMessage(locale.noEmail)}{' '}
        <a href="https://www.universe-payouts.com" target="_blank noopener noreferrer">
          {formatMessage(locale.accessPayouts)}
        </a>
        <div className={styles.tableWrapper}>
          <Table basic styles={styles.table}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{formatMessage(locale.date)}</Table.HeaderCell>
                <Table.HeaderCell>{formatMessage(locale.sentTo)}</Table.HeaderCell>
                <Table.HeaderCell>{formatMessage(locale.amountRequested)}</Table.HeaderCell>
                <Table.HeaderCell>{formatMessage(locale.status)}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {withdrawals && (
              <Table.Body>
                {withdrawals.map(requestedFund => {
                  return (
                    <Table.Row>
                      <Table.Cell>
                        {new Date(requestedFund.created_at).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric',
                        })}
                      </Table.Cell>
                      <Table.Cell>{requestedFund.email}</Table.Cell>
                      <Table.Cell>{formatAmount(intl, requestedFund.amount, currency, false)}</Table.Cell>
                      <Table.Cell>
                        <Popup
                          size="tiny"
                          pinned
                          position="top right"
                          inverted
                          trigger={<p>{requestedFund.state}</p>}
                          content={formatMessage(locale.payout)}
                        />
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            )}
          </Table>
          <Pager currentPage={currentPage} pageCount={totalPages} onPageChange={selected => changePage(selected)} />
        </div>
      </Card.Content>
    </Card>
  );
});

export default RequestedFunds;
